import { ProgressLevel, UserUnlockable } from '@viddsee/server-api-client/src/models/me/profile';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

interface State {
  missionsCount: number;
  points: {
    badges: Array<UserUnlockable>;
    level: ProgressLevel;
    experiencePoints: {
      current: number;
      requiredForNextLevel: number;
    };
  };
}

export const PointSystemStore = new Vuex.Store<State>({
  state: {
    missionsCount: 0,
    points: {
      badges: [],
      level: {
        name: '',
        image: '',
        experienceRequired: 0,
        description: '',
        unlockables: [],
        earnMessage: '',
      },
      experiencePoints: {
        current: 0,
        requiredForNextLevel: 0,
      },
    },
  },
  mutations: {
    updateMissionsCount(state, payload): void {
      state.missionsCount = payload;
    },
    updatePoints(state, payload): void {
      state.points = payload;
    },
  },
});
